function getTokenError(err_code) {
	let ret = '';
	if(err_code == 100) ret = 'カード番号必須チェックエラー';
	else if(err_code == 101) ret = 'カード番号フォーマットエラー（数字以外を含む）';
	else if(err_code == 102) ret = 'カード番号フォーマットエラー（10-16桁の範囲外）';
	else if(err_code == 110) ret = '有効期限必須チェックエラー';
	else if(err_code == 111) ret = '有効期限フォーマットエラー（数字以外を含む）';
	else if(err_code == 112) ret = '有効期限フォーマットエラー（6又は4桁以外）';
	else if(err_code == 113) ret = '有効期限フォーマットエラー（月が13以上）';
	else if(err_code == 121) ret = 'セキュリティコードフォーマットエラー（数字以外を含む）';
	else if(err_code == 122) ret = 'セキュリティコード桁数エラー';
	else ret = 'トークン取得エラー';
	ret += '('+err_code+')';
	return ret;
}

/*
global Multipayment
*/

class gmoConnectorClass {
	validateCreditCno(creditCno) {
		if(/^\d+$/.test(creditCno)) return '';
		return 'カード番号を数字でご入力ください。';
	}
	validateCreditSno(creditCno) {
		if(/^[0-9a-zA-Z]{3,4}$/.test(creditCno)) return '';
		return 'セキュリティコードをご入力ください。';
	}
	getToken(param) {
		return new Promise((resolve) => {
			if(location.href.indexOf('https://entry.universal-field.com/rsapp/') == 0) {
				Multipayment.init('9200004823006');
			} else {
				Multipayment.init('tshop00044396');
			}
			/*
			if(location.pathname.indexOf('/dev/') >= 0 || location.pathname.indexOf('/dev2/') >= 0) {
				Multipayment.init('tshop00044396');
				//Multipayment.init('tshop00024542');
			} else {
				Multipayment.init('9200000808236');
				//Multipayment.init('9100892730534');
			}*/
			Multipayment.getToken(param, (result) => {
				//console.log('---Multipayment.getToken', result)
				if(result.resultCode == '000') {
					resolve({token:result.tokenObject.token});
				} else {
					resolve({error:getTokenError(result.resultCode)});
				}
			});
		});
	}
}
export const gmoConnector = new gmoConnectorClass(null);
